export enum NotesItemsTypes {
    EQUITY = 'E',
    FINANCIAL_LINE_ITEM = 'FLI',
    FREE_TABLE_WITH_AMOUNTS = 'FT',
    RICH_TEXT = 'RT',
    SELECT = 'S',
    INPUT = 'I',
    INPUT_NO_PREVIOUS = 'I_NOP',
    MOVEMENT_SCHEDULE = 'MS',
    SUPER_TABLE = 'ST',
}
